import { useState, useEffect } from 'react'
import './styles/App.module.css'
import './styles/global.css'
import Header from './components/Header'
import BannerPrincipal from './components/BannerPrincipal'
import Habilidades from './components/Habilidades'
import QuemSomos from './components/QuemSomos'
import FAQ from './components/FAQ'
import BannerFinal from './components/BannerFinal'
import Localizacao from './components/Localizacao'
import Avaliacoes from './components/Avaliacoes'
import Footer from './components/Footer'
import SEO from './components/SEO';
import FadeInSection from './components/FadeInSection'
import { initGA, logPageView } from './analytics';

export default function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    initGA();
    logPageView();

    (function(c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "rg5m89f832");
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="app">
      <Header />
      <SEO />
      <main>
        <FadeInSection><BannerPrincipal /></FadeInSection>
        <FadeInSection><QuemSomos /></FadeInSection>
        <FadeInSection><Habilidades /></FadeInSection>
        <FadeInSection><FAQ /></FadeInSection>
        <FadeInSection><Localizacao /></FadeInSection>
        <FadeInSection><Avaliacoes /></FadeInSection>
        <FadeInSection><BannerFinal /></FadeInSection>
      </main>
      <FadeInSection><Footer /></FadeInSection>

      {showScrollTop && (
        <button 
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            backgroundColor: '#000',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            fontSize: '20px',
            cursor: 'pointer',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            transition: 'all 0.3s ease',
            animation: 'fadeIn 0.5s, pulse 2s infinite',
            opacity: '0.8',
            transform: 'translateY(0)',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '0.8';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
          }}
          aria-label="Voltar ao topo"
        >
          <i className='fas fa-angle-double-up'></i>
        </button>
      )}

      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 0.8; transform: translateY(0); }
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </div>
  )
}
